<template>
  <div
    v-if="showLoadingState"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="academyUsers"
  >

    <div class="align-items-baseline display-flex-row m-filters-and-actions">
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row m-simple-filter"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomSelectPrimary
          v-model.number="simpleFilter.tipo"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.actors"
          keyField="id"
          name="tipo_actor"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomInputPrimary
          v-model="simpleFilter.email"
          :disabled="pagination.showLoadingState"
          name="email"
          placeholder="usuario@email.com"
          type="email"
          wrapperClass="a-input-wrapper-row"
          @input="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reload"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <div class="m-dropdown-primary">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.filter"
          :disabled="pagination.showLoadingState"
          @switchDropDown="$dropDown.switchDropDown"
        />
        <MoleculeEditionAcademyUsersDropDownFilters
          :filter-seted="filter"
          @reloadListing="reloadListing"
          @searchAdvancedFilter="searchAdvancedFilter"
        />
      </div>

      <AtomButtonSecondary
        :button-secondary="buttonSecondary.create"
        :disabled="pagination.showLoadingState"
        @showModal="$modal.showModal"
      />

      <form
        autocomplete="off"
        class="m-form-row margin-left-auto"
        name="download-csv-form"
        @submit.prevent="readAcademiaUsuariosExportar"
      >
        <AtomButtonPrimary
          :button-primary="buttonPrimary"
          :disabled="pagination.showLoadingState || !usuarios.length"
        />
      </form>
    </div>

    <div class="m-table-primary">
      <table class="table-layout-fixed">
        <tr v-show="usuarios.length">
          <th
            class="text-align-left"
            width="32%"
          >
            {{ $t('mEditionAcademyUsers.table.thUser') }}
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            {{ $t('mEditionAcademyUsers.table.thDate') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionAcademyUsers.table.thCountry') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionAcademyUsers.table.thProfile') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionAcademyUsers.table.thAccess') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionAcademyUsers.table.thActors') }}
          </th>
        </tr>
        <tr
          v-for="(usuario, index) in usuarios"
          :key="index"
          class="row-data"
        >
          <td class="text-align-left">
            <span class="display-flex-row-center">
              <AtomAvatarSecondary
                avatar-class="medium"
                :user-image="usuario.avatar"
              />
              <span class="display-flex-column user-info">
                <span class="ellipsis">
                  {{ usuario.persona ? usuario.persona.razon_social : usuario.email }}
                </span>
                <small :class="getUserGlobalState(usuario.actores)">
                  {{ usuario.email }}
                </small>
              </span>
            </span>
          </td>
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment.parseZone(usuario.actores[0].fecha_alta).format('D MMM YYYY') }}
          </td>
          <td class="text-align-center">
            <span v-if="usuario.persona !== undefined && usuario.persona.domicilio !== undefined">
              {{ usuario.persona.domicilio.provincia.pais.nombre }}
            </span>
            <span v-else>
              -
            </span>
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.profile"
              :element="usuario"
              @gotToUserProfile="gotToUserProfile"
            />
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.access"
              :disabled="requests.createAcademiaActorResetPassword.isRequested &&
                requests.createAcademiaActorResetPassword.itemLoading !== usuario.id"
              :element="usuario"
              :show-loading="requests.createAcademiaActorResetPassword.isRequested &&
                requests.createAcademiaActorResetPassword.itemLoading === usuario.id"
              @createAcademiaActorResetPassword="createAcademiaActorResetPassword(usuario.id, usuario.actores[0].id)"
            />
          </td>
          <td class="text-align-center">
            <div class="m-dropdown-table">
              <AtomButtonIconRounded
                :button-icon-rounded="buttonIconRounded.actors"
                :particularComponent="`MoleculeEditionAcademyUsersDropDownActors-${index}`"
                @switchDropDown="$dropDown.switchDropDown"
              />
              <MoleculeEditionAcademyUsersDropDownActors
                :actores="usuario.actores"
                :index="index"
              />
            </div>
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { validateEmail } from '@/plugins/validation/validators'

export default {
  name: 'MoleculeEditionAcademyUsers',

  components: {
    MoleculeEditionAcademyUsersDropDownFilters: () => import('@/components/molecules/MoleculeEditionAcademyUsersDropDownFilters'),
    MoleculeEditionAcademyUsersDropDownActors: () => import('@/components/molecules/MoleculeEditionAcademyUsersDropDownActors'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      buttonIconRounded: {
        access: {
          class: 'a-button-secondary a-button-academy-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-unlock-alt',
          method: 'createAcademiaActorResetPassword',
          tooltip: this.$t('mEditionAcademyUsers.tooltip.access'),
          type: 'button'
        },

        actors: {
          class: 'a-button-secondary a-button-academy-secondary a-button-icon-rounded',
          component: '',
          icon: 'fas fa-ellipsis-v',
          method: 'switchDropDown',
          type: 'button'
        },

        profile: {
          class: 'a-button-secondary a-button-academy-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-user-astronaut',
          method: 'gotToUserProfile',
          tooltip: this.$t('mEditionAcademyUsers.tooltip.profile'),
          type: 'button'
        }
      },

      buttonPrimary: {
        action: this.$t('mEditionAcademyUsers.buttonPrimary'),
        behavior: 'download',
        class: 'a-button-academy-primary',
        sending: false,
        type: 'submit'
      },

      buttonSecondary: {
        create: {
          class: 'a-button-academy-secondary a-button-side',
          component: 'MoleculeEditionAcademyUsersModalCreate',
          icon: 'fas fa-plus',
          method: 'showModal',
          text: this.$t('mEditionAcademyUsers.buttonSecondary.createText'),
          type: 'button'
        },

        download: {
          class: 'a-button-download-secondary margin-left-auto',
          component: '',
          icon: 'fas fa-arrow-to-bottom',
          loading: false,
          method: 'readAcademiaUsuariosExportar',
          text: this.$t('mEditionAcademyUsers.buttonSecondary.downloadText'),
          type: 'button'
        },

        filter: {
          class: 'a-button-academy-secondary a-button-side',
          component: 'MoleculeEditionAcademyUsersDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionAcademyUsers.buttonSecondary.filterText'),
          type: 'button'
        },

        reload: {
          class: 'a-button-academy-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionAcademyUsers.tooltip.reload'),
          type: 'button'
        }
      },

      filter: {
        email: '',
        fecha_desde: '',
        fecha_hasta: '',
        habilitado: '',
        limite: 10,
        nombre: '',
        pagina: 1,
        pais: '',
        tipo: ''
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      requests: {
        createAcademiaActorResetPassword: {
          itemLoading: '',
          isRequested: false
        }
      },

      showLoadingState: true,

      simpleFilter: {
        email: '',
        tipo: ''
      },

      usuarios: []
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.showLoadingState = true
      this.readAcademiaUsuarios()
    }
  },
  created () {
    this.readAcademiaUsuarios()
  },

  methods: {
    // TODO: Cambiar nommbre de endpoint
    createAcademiaActorResetPassword (userId, actorId) {
      if (!this.requests.createAcademiaActorResetPassword.isRequested) {
        this.requests.createAcademiaActorResetPassword.isRequested = true
        this.requests.createAcademiaActorResetPassword.itemLoading = userId
        this.$services.create('academia', 'createAcademiaActorResetPassword', {}, [this.$store.getters.getAcademyData.id, actorId])
          .then(response => {
            this.$alerts.pushAlert('mEditionAcademyUsers', 'createAcademiaActorResetPassword', 'success')
            this.requests.createAcademiaActorResetPassword.isRequested = false
          })
          .catch(error => {
            console.log(error)
            this.$alerts.pushAlert('mEditionAcademyUsers', 'createAcademiaActorResetPassword', 'error', 'a-alert-danger')
            this.requests.createAcademiaActorResetPassword.isRequested = false
          })
      }
    },

    getUserGlobalState (actores) {
      if (actores.find(actor => actor.habilitado === 1)) {
        return 'ellipsis font-weight-regular text-color-success'
      } else {
        return 'ellipsis font-weight-regular text-color-danger'
      }
    },

    gotToUserProfile (usuario) {
      this.$router.push(`/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.users.subject')}/${usuario.id}/${this.$t('mEditionMenu.academy.users.children.profile.subedition')}/${this.$t('mEditionMenu.academy.users.children.profile.children.account.subitem')}`)
    },

    readAcademiaUsuarios () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('academia', 'readAcademiaUsuarios', {}, [this.$store.getters.getAcademyData.id], this.filter)
          .then(response => {
            console.log(response.data)
            this.usuarios = []
            this.usuarios = response.data.usuarios
            this.usuarios.forEach(usuario => {
              usuario.actores.sort((a, b) => {
                return Date.parse(a.fecha_alta) - Date.parse(b.fecha_alta)
              })
            })
            this.pagination.currentQuantity = this.usuarios.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
          .catch(error => {
            console.log(error)
            this.usuarios = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState = false
          })
      }
    },

    readAcademiaUsuariosExportar () {
      // if (!this.buttonSecondary.download.loading) {
      // this.buttonSecondary.download.loading = true
      // this.buttonSecondary.download.icon = 'fas fa-spinner fa-spin'
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.read('academia', 'readAcademiaUsuariosExportar', {}, [this.$store.getters.getAcademyData.id], this.filter)
          .then(response => {
            this.$files.downloadCsv(response.data, `${this.$t('mEditionAcademyUsers.files.users')}-${this.$moment().format('YYYYMMDD')}`)
            this.buttonPrimary.sending = false
            // this.buttonSecondary.download.loading = false
            // this.buttonSecondary.download.icon = 'fas fa-arrow-to-bottom'
            this.$alerts.pushAlert('mEditionAcademyUsers', 'readAcademiaUsuariosExportar', 'success')
          })
          .catch(error => {
            console.log(error)
            this.buttonPrimary.sending = false
            // this.buttonSecondary.download.loading = false
            // this.buttonSecondary.download.icon = 'fas fa-arrow-to-bottom'
            this.$alerts.pushAlert('mEditionAcademyUsers', 'readAcademiaUsuariosExportar', 'error', 'a-alert-danger')
          })
      }
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        email: '',
        fecha_desde: '',
        fecha_hasta: '',
        habilitado: '',
        limite: 10,
        nombre: '',
        pagina: 1,
        pais: '',
        tipo: ''
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        email: '',
        tipo: ''
      }
    },

    searchAdvancedFilter (advancedFilter) {
      this.resetSimpleFilter()
      this.filter = Object.assign({}, advancedFilter)
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      if (validateEmail(this.simpleFilter.email) ||
        this.simpleFilter.email === '') {
        this.resetAdvancedFilter()
        this.filter.email = this.simpleFilter.email
        this.filter.tipo = this.simpleFilter.tipo
        this.setPaginationCurrentPage(1)
      }
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readAcademiaUsuarios()
    }
  }
}
</script>
